
import { globalStyles } from '../../../assets/globalStyles';
import React, { ReactElement } from 'react';
import { Info } from '@material-ui/icons';
import {
    Grid,
    Typography,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Table,
    TableCell,
    TableBody,
    TableRow,
} from '@material-ui/core';
import { CorrelationResultType } from './korrelationTypes';

export default function LegendeKorrelation(
    props: { resultType: CorrelationResultType, max: number, min: number }
): ReactElement {

    const classes = {
        ...globalStyles(),
    };

    const resultType = props.resultType;
    const max = props.max;
    const min = props.min;


    const [openLegendeDialog, setOpenLegendeDialog] = React.useState(false);

    return (
        <React.Fragment>
            <Grid item md={12} style={{ textAlignLast: "right", marginTop: "-24px", marginBottom: "5px" }}>
                <Button
                    component={"div"}
                    onClick={() => {
                        openLegendeDialog ? setOpenLegendeDialog(false) : setOpenLegendeDialog(true)
                    }}
                    style={{ minWidth: "unset", marginLeft: "20px", color: "rgb(177, 177, 177)" }}
                >Legende
                    <Info style={{ marginLeft: "10px" }} />
                </Button>
                <Dialog open={openLegendeDialog} onClose={() => setOpenLegendeDialog(false)}>
                    <DialogTitle color="primary">Legende Korrelation{resultType != CorrelationResultType.single ? " (Anzahl)" : ""}</DialogTitle>
                    <DialogContent>
                        <DialogContentText style={{ padding: "30px" }}>
                            <Typography style={{ paddingBottom: "0px", marginBottom: "0px" }} >Werte</Typography>
                            {resultType != CorrelationResultType.count ? (
                                resultType != CorrelationResultType.percentage ?
                                    <Table aria-label="simple table" >
                                        <TableBody>
                                            <TableRow >
                                                <TableCell style={{ width: "10px", backgroundImage: "linear-gradient(to top, hsl(0, 100%,75%), hsl(0, 100%,50%))", border: "white" }} ></TableCell>
                                                <TableCell style={{ border: "white", paddingTop: "0px" }} >1.0</TableCell>
                                            </TableRow >
                                            <TableRow >
                                                <TableCell style={{ width: "10px", backgroundImage: "linear-gradient(to top, hsl(0, 100%,100%), hsl(0, 100%,75%))", border: "white" }} ></TableCell>
                                                <TableCell style={{ border: "white", paddingTop: "0px" }} >0.5</TableCell>
                                            </TableRow >
                                            <TableRow >
                                                <TableCell style={{ width: "10px", backgroundImage: "linear-gradient(to top, hsl(0, 100%,100%), hsl(0, 100%,100%))", border: "white", paddingBottom: "0px", paddingTop: "0px" }} ></TableCell>
                                                <TableCell style={{ border: "white", paddingBottom: "0px", paddingTop: "0px" }} >0.0</TableCell>
                                            </TableRow >
                                            <TableRow >
                                                <TableCell style={{ width: "10px", backgroundImage: "linear-gradient(to top, hsl(240, 100%,75%), hsl(0, 100%,100%))", border: "white" }} ></TableCell>
                                                <TableCell style={{ border: "white", paddingBottom: "0px" }} >- 0.5</TableCell>
                                            </TableRow >
                                            <TableRow >
                                                <TableCell style={{ width: "10px", backgroundImage: "linear-gradient(to top, hsl(240, 100%,50%), hsl(240, 100%,75%))", border: "white" }} ></TableCell>
                                                <TableCell style={{ border: "white", paddingBottom: "0px" }} >- 1.0</TableCell>
                                            </TableRow >
                                            <TableRow >
                                                <TableCell style={{ width: "10px", backgroundColor: "#eeeeee", height: "1px", maxHeight: "2px", border: "white", padding: "0px" }} ></TableCell>
                                                <TableCell style={{ border: "white", paddingBottom: "5px", paddingTop: "5px" }} >Keine Daten</TableCell>
                                            </TableRow >
                                        </TableBody>
                                    </Table>
                                    :
                                    <Table aria-label="simple table" >
                                        <TableBody>
                                            <TableRow >
                                                <TableCell style={{ width: "10px", backgroundImage: "linear-gradient(to top, hsl(0, 100%,25%), hsl(0, 100%,0%))", border: "white" }} ></TableCell>
                                                <TableCell style={{ border: "white", paddingTop: "0px" }} >100%</TableCell>
                                            </TableRow >
                                            <TableRow >
                                                <TableCell style={{ width: "10px", backgroundImage: "linear-gradient(to top, hsl(0, 100%,50%), hsl(0, 100%,25%))", border: "white" }} ></TableCell>
                                                <TableCell style={{ border: "white" }} >75%</TableCell>
                                            </TableRow >
                                            <TableRow >
                                                <TableCell style={{ width: "10px", backgroundImage: "linear-gradient(to top, hsl(0, 100%,62%), hsl(0, 100%,50%))", border: "white" }} ></TableCell>
                                                <TableCell style={{ border: "white" }} >50%</TableCell>
                                            </TableRow >
                                            <TableRow >
                                                <TableCell style={{ width: "10px", backgroundImage: "linear-gradient(to top, hsl(0, 100%,86%), hsl(0, 100%,62%))", border: "white" }} ></TableCell>
                                                <TableCell style={{ border: "white" }} >25%</TableCell>
                                            </TableRow >
                                            <TableRow >
                                                <TableCell style={{ width: "10px", backgroundImage: "linear-gradient(to top, hsl(0, 100%,100%), hsl(0, 100%,86%))", border: "white" }} ></TableCell>
                                                <TableCell style={{ border: "white", paddingBottom: "0px" }} >0%</TableCell>
                                            </TableRow >
                                            <TableRow >
                                                <TableCell style={{ width: "10px", backgroundImage: "linear-gradient(to right, hsl(0, 0%,99%), hsl(0, 0%,100%), hsl(0, 0%,99%)", border: "white", padding: "1px" }} ></TableCell>
                                            </TableRow >
                                            <TableRow >
                                                <TableCell style={{ width: "10px", backgroundColor: "#eeeeee", height: "1px", maxHeight: "2px", border: "white", padding: "0px" }} ></TableCell>
                                                <TableCell style={{ border: "white", paddingBottom: "5px", paddingTop: "5px" }} >Keine Daten</TableCell>
                                            </TableRow >
                                        </TableBody>
                                    </Table>
                            )
                                :
                                <Table aria-label="simple table" >
                                    <TableBody>
                                        <TableRow >
                                            <TableCell style={{ width: "10px", backgroundImage: "linear-gradient(to top, hsl(120, 60%,25%), hsl(120, 60%,0%)", border: "white" }} ></TableCell>
                                            <TableCell style={{ border: "white", paddingTop: "0px" }} >{max}</TableCell>
                                        </TableRow >
                                        <TableRow >
                                            <TableCell style={{ width: "10px", backgroundImage: "linear-gradient(to top, hsl(120, 60%,50%), hsl(120, 60%,25%)", border: "white" }} ></TableCell>
                                            <TableCell style={{ border: "white", paddingTop: "0px" }} >{max * 0.75}</TableCell>
                                        </TableRow >
                                        <TableRow >
                                            <TableCell style={{ width: "10px", backgroundImage: "linear-gradient(to top, hsl(120, 60%,75%), hsl(120, 60%,50%)", border: "white" }} ></TableCell>
                                            <TableCell style={{ border: "white", paddingBottom: "0px", paddingTop: "0px" }} >{max * 0.5}</TableCell>
                                        </TableRow >
                                        <TableRow >
                                            <TableCell style={{ width: "10px", backgroundImage: "linear-gradient(to top, hsl(120, 60%,100%),hsl(120, 60%,75%)", border: "white" }} ></TableCell>
                                            <TableCell style={{ border: "white" }} >{max * 0.25}</TableCell>
                                        </TableRow >
                                        <TableRow >
                                            <TableCell style={{ width: "10px", height: "1px", maxHeight: "2px", backgroundImage: "linear-gradient(to right, hsl(0, 0%,99%), hsl(0, 0%,100%), hsl(0, 0%,99%)", border: "white", padding: "0px" }} ></TableCell>
                                            <TableCell style={{ border: "white", paddingBottom: "0px", paddingTop: "0px" }} >{min}</TableCell>
                                        </TableRow >
                                        <TableRow >
                                            <TableCell style={{ width: "10px", backgroundColor: "#eeeeee", height: "1px", maxHeight: "2px", border: "white", padding: "0px" }} ></TableCell>
                                            <TableCell style={{ border: "white", paddingBottom: "5px", paddingTop: "5px" }} >Keine Daten</TableCell>
                                        </TableRow >
                                    </TableBody>
                                </Table>
                            }
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            color="secondary"
                            variant="contained"
                            onClick={() => setOpenLegendeDialog(false)}
                            className={classes.cancleDeleteButton}
                        >
                            Schliessen
                        </Button>
                    </DialogActions>
                </Dialog>
            </Grid>
        </React.Fragment>
    )
}
